export const getCoords = async (): Promise<GeolocationCoordinates | null> => {
	if (!('permissions' in navigator) || !('geolocation' in navigator)) {
		return null
	}

	try {
		const {state} = await navigator.permissions.query({
			name: 'geolocation',
		})

		if (state !== 'granted') {
			return null
		}

		return await new Promise<GeolocationCoordinates | null>((resolve) => {
			navigator.geolocation.getCurrentPosition(
				({coords}) => {
					resolve(coords)
				},
				() => {
					resolve(null)
				}
			)
		})
	} catch {
		return null
	}
}
